import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';


@Component({
  selector: 'app-foerderung',
  templateUrl: './foerderung.component.html',
  styleUrls: ['./foerderung.component.css']
})
export class FoerderungComponent implements OnInit {
  anwendungsname = ConstantsTexte.ANWENDUNGSNAME;

  faArrowLeft = faArrowLeft;

  constructor(private location: Location) {}

  ngOnInit(): void {
  }

  goBack() {
    this.location.back();
  }  
}
